import React from 'react';

import {withStyles} from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid/Grid";
import Colors from "../../template/Colors";
import { Tooltip } from '@material-ui/core';

const style = theme => ({
    listItem: {
        marginBottom: '5px'
    },
    itemTitle: {
        color: Colors.commons.secondary,
        fontSize: '12px',
        fontFamily: 'Poppins!important',
    },
    
    itemValue: {
        color: Colors.commons.gray7,
        height: '16px',
        fontFamily: 'Poppins!important',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 250,
    },
    itemValueSub: {
        color: Colors.commons.gray7,
        borderBottom: `1px solid ${Colors.commons.gray6}`,
        height: '16px',
        fontFamily: 'Poppins!important', 
        marginRight: '4px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 250,
    },
});

const ItemList = (props) => {
    const {field, value, classes, size, lineBottom = true, color, tooltipTitle = ""} = props;
    const itemValueClass = lineBottom ? classes.itemValueSub : classes.itemValue;
    return <Tooltip title={tooltipTitle} placement='top'>
        <Grid item xs={size} className={classes.listItem}>
            <div className={classes.itemTitle}>{field}</div>
            {
                color ? 
                <div 
                    style={{ 
                        backgroundColor: color, 
                        borderRadius: 10,
                        height: 12,
                        marginTop: 5
                    }}
                />
                :
                <div className={itemValueClass}>{value}</div>
            }
        </Grid>
    </Tooltip> 
};


export default withStyles(style)(ItemList);